/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';

import Editor from '../fw/Editor.react';
import urlMapping from '../app/URLMapping';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'apiKeyAdd.title', 'defaultMessage': 'Create new API Key'}
});

interface ApiKeyAddProps {
    intl: IntlShape;
    user: User;
}

class ApiKeyAdd extends React.Component<ApiKeyAddProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'apiKeys';

    constructor() {
        super();
    }

    render() {
        let type = types[this.typeName];

        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)} titleAsHeader>

                <Editor
					cancelable
                    columns={['description', 'validFrom', 'validTo']}
                    fatQuery={Relay.QL `fragment on CreateApiKeyPayload @relay(pattern: true) {
                        edge {
                            node {
                                id,
                                realId,
                                user_id,
                                validFrom,
                                validTo,
                                description,
                            }
                        },
                        user {
                            id,
                            apiKeys(first: 2000) {
                                edges {
                                    node {
                                        id,
                                    }
                                }
                            }
                        }
                    }`}
                    isCreate
                    metadata={type}
                    mutation={Relay.QL `mutation { createApiKey }`}
                    organisationId={this.props.user.organisation.realId}
                    parent={{id: this.props.user.realId, organisation_id: this.props.user.organisation.realId}}
                    redirectToList
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ApiKeyAdd), (props) => {
    return props.user;
}), {
    initialVariables: {
        organisationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                realId,
                firstname,
                surname,
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                },
            }
        `,
    },
});
